import { Avatar, Box, Typography } from "@mui/material";
import IMessage from "../../../../interface/IMessage";
import React from "react";
import RenderMessageContent from "../renderMessageContent/renderMessageContent";
import { AppContext } from "../../../../store/genesys.context";
import MessageBot from "../../../atoms/text/messageBot.styled";
import RenderMessage from "../renderMessage/renderMessage";

const RenderBotMessage = ({
  message,
}: {
  message: IMessage;
}): React.JSX.Element => {
  const {
    getAgentAvatar,
  }: {
    getAgentAvatar: (message: IMessage) => string;
  } = React.useContext(AppContext);
  const agentName = message.agent.name?.trim()
    ? message.agent.name.trim()
    : "Mia";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-end",
          gap: "5px",
        }}
      >
        {message.timeStamp !== null && (
          <Avatar
            alt={agentName}
            src={getAgentAvatar(message)}
            sx={{
              mr: 1,
            }}
          />
        )}

        {message.text && (
          <MessageBot isLast={message.timeStamp === null}>
            <RenderMessage message={message} />
          </MessageBot>
        )}

        {message.content && (
          <MessageBot isLast={message.timeStamp === null}>
            <RenderMessageContent content={message.content} sender="bot" />
          </MessageBot>
        )}
      </Box>

      {message.timeStamp && (
        <RenderTimeStamp timeStamp={message.timeStamp} message={message} />
      )}
    </Box>
  );
};

export default RenderBotMessage;

const RenderTimeStamp = ({
  timeStamp,
  message,
}: {
  timeStamp: string | null;
  message: IMessage;
}) => {
  const {
    getAgentName,
  }: {
    getAgentName: (message: IMessage) => string;
  } = React.useContext(AppContext);

  return (
    <Typography
      variant="caption"
      sx={{
        position: "relative",
        left: "50px",
        mb: timeStamp === null ? "0" : "10px",
        color: (theme) => theme.palette.text.secondary,
      }}
    >
      {`${timeStamp} | ${getAgentName(message)}`}
    </Typography>
  );
};
